module.exports = __webpack_public_path__ + "static/media/pla_sit_spe_con.b7182cf2.png";